/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AppsPreview from 'ui/components/theme/AppsPreview.vue';

/**
 * This component is used to render editorial content.
 * It can be used to render paragraphs of text.
 * The property "paragraphs" is an array of objects with the following structure:
 *
 * {
 *    text: 'paragraph text',
 *    [class]: 'paragraph class',
 *    [wrapper]: 'wrapper class'
 * }
 *
 * A full example of the kind is as follows:
 *
 * @example
 * "my-intro-text": {
 *    "kind": "editorial",
 *    "kind_options": {
 *       "paragraphs": [
 *         {    }
 *       ]
 *    }
 * }
 *
 * @example
 * "preview": {
 *     "order": 100,
 *     "no_category": true,
 *     "kind": "editorial",
 *     "kind_options": {
 *         "components": ["AppsPreview"]
 *     }
 * }
 */

const __vue_script__ = {
    name: 'EditorialContent',

    components: {
        AppsPreview
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        model: {
            type: Object,
            required: true
        },

        paragraphs: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        },

        components: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        paragraphText(paragraph) {
            const content = paragraph.text;
            return this.$te(content) ? this.$t(content) : content;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editorial-content"},[_vm._l((_vm.paragraphs),function(paragraph){return [(paragraph.wrapper)?[_c('div',{class:paragraph.wrapper},[_c('p',{class:paragraph.class},[_vm._v(_vm._s(_vm.paragraphText(paragraph)))])])]:[_c('p',{class:paragraph.class},[_vm._v(_vm._s(_vm.paragraphText(paragraph)))])]]}),_vm._l((_vm.components),function(component){return _c(component,{tag:"component",attrs:{"event":_vm.event,"model":_vm.model,"options":_vm.options}})})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EditorialContent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__